<template>
  <div class="entry-overview flex overflow-hidden bg-white shadow sm:rounded-lg">
    <div class="entry-detail w-full">
      <div class="flex flex-col">
        <!-- Header -->
        <DestinationHeader
          :destination="destination"
          :button="false" />
        <!-- Main content -->
        <main class="mx-auto w-full max-w-8xl flex-1">
          <div class="relative p-4">
            <div class="h-fit">
              <TableWithCondensedContent
                classes="w-full"
                heading="All proposals from this destination"
                ingress="Here you can see all (excluding hidden) proposals for this destination."
                table-bold
                has-search
                has-paginator
                has-cell-link
                sort-key="Created / Starts"
                sort-order="desc"
                cell-link-text="Go to proposal"
                :button="{ text: 'Create new proposal', link: route('proposals.create') }"
                :table-headers="['Client / Budget', 'Proposal Heading', 'Created / Starts', 'Status']"
                :table-rows="destination.proposals.map((proposal) => {
                  return [
                    [
                      proposal.client.name,
                      (proposal.project.total_travelers ?? '0') + ' pax' + ' &times; ' + (formatCurrency(proposal.project.budget_per_traveller) ?? '-'),
                    ],
                    [
                      proposal.title ?? '-',
                      proposal.data.destination.heading ?? '-',
                    ],
                    [
                      proposal.created_at ? getDateTimeInCurrentTimezone(proposal.created_at, 'DD.MM.YYYY') : '-',
                      '&nbsp;&nbsp;&nbsp;' + (proposal.start_date ? getDateTimeInDestinationTimezone(proposal.start_date, proposal.data.destination.timezone, 'DD.MM.YYYY') : '-'),
                    ],
                    {
                      type: 'status-badge',
                      value: proposal.status,
                    },
                    route('proposals.show', {id: proposal.id}),
                  ];
                })" />
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup>
/* external */

/* local */
import {
  formatCurrency,
  getDateTimeInCurrentTimezone,
  getDateTimeInDestinationTimezone,
} from '@/utils';
import DestinationHeader from '@/Pages/Destination/Components/DestinationHeader';
import TableWithCondensedContent from '@/Components/Lists/TableWithCondensedContent';

defineProps({
  destination: {
    type: Object,
    required: true,
  },
});

</script>
